import * as React from "react";

const SvgFilterEllipsis = (props: ISvgIcons) => {
  return (
    <svg
      width={props.size}
      height={props.size}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={"0 0 24 24"}
      {...props}
    >
      <g
        stroke={props.color}
        strokeWidth={props.weight}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect={"non-scaling-stroke"}
      >
        <circle cx={3.625} cy={11.625} r={2.625} />
        <circle cx={20.875} cy={11.625} r={2.625} />
        <circle cx={12.25} cy={11.625} r={2.625} />
      </g>
    </svg>
  );
};

export default SvgFilterEllipsis;
